import {
    take,
    put,
    call,
    all,
    takeLatest,
    takeEvery,
} from 'redux-saga/effects';
import { MoodRatingActions as actions, notificationActions } from '../actions';
import { MoodRatingService } from '../services';

/* Add MoodRating Sagas */
function* handleSaveMoodRatingRequest() {
    const action = yield take(actions.saveMoodRatingRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(MoodRatingService.saveMoodRating, dataParams);
        if (res.isError) {
            yield put(actions.saveMoodRatingError(res));
            // yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.saveMoodRatingSuccess(res));
            // yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.saveMoodRatingError());
        // yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/* Get All MoodRating Sagas */
function* handleGetAllMoodRatingRequest() {
    const action = yield take(actions.getAllMoodRatingRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(MoodRatingService.getAllMoodRating, dataParams);
        if (res.isError) {
            yield put(actions.getAllMoodRatingError(res));

        } else {
            yield put(actions.getAllMoodRatingSuccess(res));
        }

    } catch (error) {
        yield put(actions.getAllMoodRatingError());
    }
}

/* Get All MoodRating Sagas */
function* handleFindDailyMoodRatingRequest() {
    const action = yield take(actions.findDailyMoodRatingRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(MoodRatingService.findDailyMoodRating, dataParams);
        if (res.isError) {
            yield put(actions.findDailyMoodRatingError(res));

        } else {
            yield put(actions.findDailyMoodRatingSuccess(res));
        }

    } catch (error) {
        yield put(actions.findDailyMoodRatingError());
    }
}

/* Get MoodRating By Department Sagas */
function* handleFindAllMoodRatingRequest() {
    const action = yield take(actions.findAllMoodRatingRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(MoodRatingService.findAllMoodRating, dataParams);
        if (res.isError) {
            yield put(actions.findAllMoodRatingError(res));

        } else {
            yield put(actions.findAllMoodRatingSuccess(res));
        }

    } catch (error) {
        yield put(actions.findAllMoodRatingError());
    }
}

/* Update MoodRating Sagas */
function* handleRatingPercentRequest() {
    const action = yield take(actions.ratingPercentRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(MoodRatingService.ratingPercent, dataParams);
        if (res.isError) {
            yield put(actions.ratingPercentError(res));
        } else {
            yield put(actions.ratingPercentSuccess(res));
        }
    } catch (error) {
        yield put(actions.ratingPercentError());
    }
}
/* Delete MoodRating Sagas */
function* handleDayWiseCoverageRequest() {
    const action = yield take(actions.dayWiseCoverageRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(MoodRatingService.dayWiseCoverage, dataParams);
        if (res.isError) {
            yield put(actions.dayWiseCoverageError(res));
        } else {
            yield put(actions.dayWiseCoverageSuccess(res));
        }
    } catch (error) {
        yield put(actions.dayWiseCoverageError());
    }
}

/* Add MoodRating Sagas */
function* handleKeyFunctionDataRequest() {
    const action = yield take(actions.keyFunctionDataRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(MoodRatingService.keyFunctionData, dataParams);
        if (res.isError) {
            yield put(actions.keyFunctionDataError(res));

        } else {
            yield put(actions.keyFunctionDataSuccess(res));
        }
    } catch (error) {
        yield put(actions.keyFunctionDataError());
    }
}

/* Get All MoodRating Sagas */
function* handleKeyEmployeeDataRequest() {
    const action = yield take(actions.keyEmployeeDataRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(MoodRatingService.keyEmployeeData, dataParams);
        if (res.isError) {
            yield put(actions.keyEmployeeDataError(res));

        } else {
            yield put(actions.keyEmployeeDataSuccess(res));
        }

    } catch (error) {
        yield put(actions.keyEmployeeDataError());
    }
}


/* -----------Watchers------------- */
function* handleSaveMoodRatingWatcher() {
    yield takeEvery(
        actions.saveMoodRatingRequest,
        handleSaveMoodRatingRequest,
    );
}

function* handleGetAllMoodRatingWatcher() {
    yield takeEvery(
        actions.getAllMoodRatingRequest,
        handleGetAllMoodRatingRequest,
    );
}

function* handleFindDailyMoodRatingWatcher() {
    yield takeEvery(
        actions.findDailyMoodRatingRequest,
        handleFindDailyMoodRatingRequest,
    );
}

function* handleFindAllMoodRatingWatcher() {
    yield takeEvery(
        actions.findAllMoodRatingRequest,
        handleFindAllMoodRatingRequest,
    );
}

function* handleRatingPercentWatcher() {
    yield takeEvery(
        actions.ratingPercentRequest,
        handleRatingPercentRequest,
    );
}

function* handleDayWiseCoverageWatcher() {
    yield takeEvery(
        actions.dayWiseCoverageRequest,
        handleDayWiseCoverageRequest,
    );
}

function* handleKeyFunctionDataWatcher() {
    yield takeEvery(
        actions.keyFunctionDataRequest,
        handleKeyFunctionDataRequest,
    );
}

function* handleKeyEmployeeDataWatcher() {
    yield takeEvery(
        actions.keyEmployeeDataRequest,
        handleKeyEmployeeDataRequest,
    );
}

function* rootMoodRatingSaga() {
    yield all([
        handleSaveMoodRatingRequest(),
        handleSaveMoodRatingWatcher(),

        handleGetAllMoodRatingRequest(),
        handleGetAllMoodRatingWatcher(),

        handleFindDailyMoodRatingRequest(),
        handleFindDailyMoodRatingWatcher(),

        handleFindAllMoodRatingRequest(),
        handleFindAllMoodRatingWatcher(),

        handleRatingPercentRequest(),
        handleRatingPercentWatcher(),

        handleDayWiseCoverageRequest(),
        handleDayWiseCoverageWatcher(),

        handleKeyFunctionDataRequest(),
        handleKeyFunctionDataWatcher(),

        handleKeyEmployeeDataRequest(),
        handleKeyEmployeeDataWatcher(),
    ]);
}

export default rootMoodRatingSaga;
